/**
 * Кастомная иконка «Добавить пользователя» (filled)
 *
 * fill="currentColor" для окрашивания через Tailwind
 * Совместима с IconComponent (принимает size, style, className)
 */

import type { CSSProperties } from 'react';

interface IconProps {
  className?: string;
  size?: number | string;
  style?: CSSProperties;
}

export function AddUserIcon({ className, size, style }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0282 14.0011C6.13697 14.0011 2.84888 16.1672 2.84888 18.7311C2.84888 22.0465 8.25205 22.0465 10.0282 22.0465C13.111 22.0465 17.2096 21.7049 17.2096 18.7522C17.2096 16.1762 13.9205 14.0011 10.0282 14.0011Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0291 11.8199H10.0615C11.3337 11.8159 12.5283 11.3045 13.4243 10.3812C14.3212 9.45795 14.8124 8.23326 14.8075 6.93423C14.8075 4.2387 12.6649 2.04651 10.0291 2.04651C7.39432 2.04651 5.25171 4.2387 5.25171 6.93423C5.25171 9.62774 7.39432 11.8199 10.0291 11.8199Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0451 11.1833H18.653V9.81669C18.653 9.36588 18.2923 9 17.848 9C17.4036 9 17.0429 9.36588 17.0429 9.81669V11.1833H15.6551C15.2107 11.1833 14.8501 11.5492 14.8501 12C14.8501 12.4508 15.2107 12.8167 15.6551 12.8167H17.0429V14.1833C17.0429 14.6341 17.4036 15 17.848 15C18.2923 15 18.653 14.6341 18.653 14.1833V12.8167H20.0451C20.4895 12.8167 20.8501 12.4508 20.8501 12C20.8501 11.5492 20.4895 11.1833 20.0451 11.1833Z"
        fill="currentColor"
      />
    </svg>
  );
}